import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

import CheckCircleIcon from 'public/check-circle-icon.svg';

export const MedicationSVG = styled(InlineSVG).attrs({ src: CheckCircleIcon })`
  svg {
    width: 20px;
    height: 20px;
  }
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MedicationsChipListContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space.s3};
  padding: 0;
  margin: 0;
  list-style: none;
  margin-right: ${({ theme }) => theme.space.s3};
`;

export const MedicationChipContainer = styled.li`
  display: flex;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 3px;
  background: var(--green-60, #008674);
  color: white;
  svg {
    path {
      fill: white;
    }
  }
`;

export const MedicationChipContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  svg {
    width: 18px;
    height: 18px;
    stroke: white;
  }
`;
